const LocaleConfig = {
  // common
  saveText: 'Save',
  setText: 'Settings',
  saveSuccessText: 'Save Successful',
  saveFailedText: 'Save Failed',
  addFriendSuccessText: 'Add Friend Successful',
  applyFriendSuccessText: 'Friend Request Sent Successfully',
  addFriendFailedText: 'Add Friend Failed',
  applyFriendFailedText: 'Friend Request Failed',
  okText: 'OK',
  cancelText: 'Cancel',
  deleteText: 'Delete',
  recallText: 'Recall',
  forwardText: 'Forward',
  forwardSuccessText: 'Forward Successful',
  forwardFailedText: 'Forward Failed',
  recentForwardText: 'Recent Forward',
  sendBtnText: 'Send',
  replyText: 'Reply',
  commentText: 'Comment',
  recentSessionText: 'Recent Sessions',
  you: 'You',
  deleteFriendText: 'Delete Friend',
  confirmDeleteText: 'Confirm Deletion?',
  confirmDeleteFriendText: 'Confirm Delete Friend?',
  deleteFriendSuccessText: 'Delete Friend Successful',
  deleteFriendFailedText: 'Delete Friend Failed',
  blackText: 'Block Friend',
  removeBlackText: 'Unblock',
  blackSuccessText: 'Block Successful',
  blackFailedText: 'Block Failed',
  removeBlackSuccessText: 'Unblock Successful',
  removeBlackFailedText: 'Unblock Failed',
  maxSelectedText: 'Maximum Selection',
  selectedText: 'Selected',
  strangerText: 'Strangers',
  emailErrorText: 'Invalid Email Format',
  uploadLimitText: 'Maximum Upload Size',
  uploadLimitUnit: 'M',
  uploadImgFailedText: 'Upload Image Failed',
  accountText: 'Account',
  nickText: 'Nickname',
  genderText: 'Gender',
  phoneText: 'Phone',
  emailText: 'Email',
  signText: 'Signature',
  accountPlaceholder: 'Please Enter Account',
  teamIdPlaceholder: 'Please Enter Group ID',
  nickPlaceholder: 'Please Enter Nickname',
  genderPlaceholder: 'Please Select Gender',
  phonePlaceholder: 'Please Enter Phone Number',
  emailPlaceholder: 'Please Enter Email',
  signPlaceholder: 'Please Enter Signature',
  searchInputPlaceholder: 'Search',
  searchTeamMemberPlaceholder: 'Search Group Members',
  searchDiscussionMemberPlaceholder: 'Search Discussion Group Members',
  searchText: 'Search',
  man: 'Male',
  woman: 'Female',
  unknow: 'Unknown',
  welcomeText: 'Welcome to Yunxin',
  notSupportMessageText: 'Message Not Supported',
  applyTeamText: 'Apply to Join Group',
  applyTeamSuccessText: 'Application to Join Group Successful',
  rejectText: 'Reject',
  acceptText: 'Accept',
  inviteTeamText: 'Invite You to Join',
  applyFriendText: 'Add You as Friend',
  acceptResultText: 'Accepted',
  rejectResultText: 'Rejected',
  expiredResultText: 'Expired',
  beRejectResultText: 'Friend Request Rejected',
  passResultText: 'Friend Request Accepted',
  rejectTeamInviteText: 'Group Invite Rejected',
  updateTeamAvatar: 'Updated Group Avatar',
  updateTeamName: 'Updated Group Name to',
  openApplyModeText: 'opened the group joining review',
  closeApplyModeText: 'closed the group joining review',
  openAgreeModeText: 'opened the group invitation needs to be agreed',
  closeAgreeModeText: 'closed the group invitation needs to be agreed',
  processedValidationMessageText: 'The verification message has been processed',
  teamNotExitsText: 'Group Not Found',
  teamMemberLimitText: 'Group Member Limit Reached',
  verifyMsgNotExitsText: 'The verification message has been processed',
  aleadyInTeamText: 'Already in Group',
  updateTeamIntro: 'Updated Group Introduction',
  voiceToTextFailedText: 'Speech to text failed',
  updateTeamInviteMode: 'Updated Group Permission "Invite Others" to',
  updateTeamUpdateTeamMode: 'Updated Group Permission "Edit Group Info" to',
  updateAllowAt: 'Updated "@Everyone Permission" to',
  updateAllowTop: 'Pin Message Permission Updated to',
  createTeamMemberLimitText: 'Group Member Limit',
  addMessageTop: 'Pinned a Message',
  removeMessageTop: 'Removed Pinned Message',
  updateTeamMute: 'Updated "Group Mute" to',
  onlyTeamOwner: 'Only Group Owner',
  teamAll: 'Everyone',
  closeText: 'Close',
  openText: 'Open',
  inviteText: 'Invite',
  aliasText: 'Alias',
  updateAliasSuccessText: 'Alias Update Successful',
  updateAliasFailedText: 'Alias Update Failed',
  sendText: 'Send Message',
  noPermission: 'You Do Not Have Permission',
  unreadText: 'Unread',
  readText: 'Read',
  voiceToText: 'Speech to text',
  allReadText: 'All Read',
  allUnReadText: 'All Unread',
  amap: 'Amap',
  txmap: 'Tencent Map',
  bdmap: 'Baidu Map',
  callDurationText: 'Call Duration',
  callCancelText: 'Cancelled',
  callRejectedText: 'Rejected',
  callTimeoutText: 'Timed Out',
  callBusyText: 'Recipient Busy',
  cancelUploadFailedText: 'Cancel Upload Failed',
  // conversation-kit
  onDismissTeamText: 'Group Disbanded',
  onDismissDiscussionText: 'Discussion Group Disbanded',
  onRemoveTeamText: 'You Have Been Removed from the Group',
  textMsgText: 'Text Message',
  customMsgText: 'Custom Message',
  audioMsgText: 'Audio Message',
  videoMsgText: 'Video Message',
  fileMsgText: 'File Message',
  callMsgText: 'Call Log Message',
  geoMsgText: 'Location Message',
  geoMsgShortText: 'Location',
  imgMsgText: 'Image Message',
  notiMsgText: 'Notification Message',
  robotMsgText: 'Robot Message',
  tipMsgText: 'Tip Message',
  unknowMsgText: 'Unknown Message',
  deleteSessionText: 'Delete Session',
  recentConversationText: 'Recent Conversations',
  muteSessionText: 'Mute Notifications',
  unmuteSessionText: 'Unmute Notifications',
  deleteStickTopText: 'Unpin',
  addStickTopText: 'Pin Message',
  beMentioned: '[Someone @me]',
  aiConversationSelectFailed: 'AI Conversation Selection Failed',
  friendText: 'Friend',
  aiUserText: 'Digital Person',
  // contact-kit
  teamListTitle: 'My Groups',
  friendListTitle: 'My Friends',
  blackListTitle: 'Blacklist',
  msgListTitle: 'Message Center',
  blackListDesc:
    '(You will not receive any messages from contacts in this list)',
  aiListTitle: 'My Digital Persons',
  teamMenuText: 'My Groups',
  friendMenuText: 'My Friends',
  blackMenuText: 'Blacklist',
  aiMenuText: 'My Digital Persons',
  msgMenuText: 'Message Center',
  acceptedText: 'Application Accepted',
  acceptFailedText: 'Application Acceptance Failed',
  rejectedText: 'Application Rejected',
  rejectFailedText: 'Application Rejection Failed',
  rejectedTeamText: 'Reject Group Application',
  rejectTeamFailedText: 'Failed to Reject Group Application',
  getApplyMsgFailedText: 'Failed to Retrieve Messages',
  // search-kit
  addFriendText: 'Add Friend',
  createTeamText: 'Create Group',
  createDiscussionText: 'Create Discussion Group',
  joinTeamText: 'Join Group',
  joinTeamSuccessText: 'Join Group Successful',
  joinTeamWithVerifyText: 'Join Group Application Sent',
  joinTeamFailedText: 'Join Group Failed',
  beRemoveTeamText: 'Removed from Group',
  addButtonText: 'Add',
  addSuccessText: 'Add Successful',
  addFailedText: 'Add Failed',
  createButtonText: 'Create',
  createTeamSuccessText: 'Create Group Successful',
  createTeamFailedText: 'Create Group Failed',
  chatButtonText: 'Go to Chat',
  getRelationFailedText: 'Failed to Get Relationship',
  accountNotMatchText: 'Account Not Found',
  teamIdNotMatchText: 'Group ID Not Found',
  searchButtonText: 'Search',
  searchTeamPlaceholder: 'Enter Group Name',
  teamTitle: 'Group Name',
  discussionTitle: 'Discussion Group Name',
  teamAvatarText: 'Group Avatar',
  discussionAvatarText: 'Discussion Group Avatar',
  addTeamMemberText: 'Add Member',
  searchEmptyText: 'You Have Not Added Any Friends or Groups Yet',
  searchNoResText: 'No Results Found',
  searchFriendTitle: 'Friends',
  searchTeamTitle: 'Groups',
  searchDiscussionTitle: 'Discussion Groups',

  notSupportJoinText:
    'Discussion Groups Cannot Be Joined Directly, Please Contact the Administrator to Add You to the Group',
  // chat-kit
  sendToText: 'Send to',
  topText: 'Pin',
  unTopText: 'Unpin',
  topFailedText: 'Pin Failed',
  collection: 'Collect',
  collectionSuccess: 'Collected',
  collectionFailed: 'Collect Failed',
  msgRecallTimeErrorText: 'The time has passed and cannot be recalled',
  getCollectionFailed: 'Failed to Retrieve Collection List',
  removeCollectionSuccess: 'Delete Collection Successful',
  removeCollectionFailed: 'Delete Collection Failed',
  confirmRemoveCollection: 'Confirm Delete Collection?',
  sendUsageText: '(Press enter to send, shift+enter to newline)',
  sendEmptyText: 'Cannot Send Blank Messages',
  teamMutePlaceholder: 'Group Chat is Muted',
  enterTeamText: 'Entered the Group',
  leaveTeamText: 'Left the Group',
  leaveDiscussionText: 'Left the Discussion Group',
  teamMuteText: 'Group Mute',
  muteAllTeamSuccessText: 'Enable Mute All Successful',
  unmuteAllTeamSuccessText: 'Unmute all members successfully',
  muteAllTeamFailedText: 'Failed to mute all members',
  unmuteAllTeamFailedText: 'Failed to unmute all members',
  updateTeamSuccessText: 'Update successful',
  updateTeamFailedText: 'Update failed',
  leaveTeamSuccessText: 'Successfully left the group',
  leaveDiscussionSuccessText: 'Successfully left the discussion group',
  leaveTeamFailedText: 'Failed to leave the group',
  leaveDiscussionFailedText: 'Failed to leave the discussion group',
  dismissTeamSuccessText: 'Group disbanded successfully',
  dismissTeamFailedText: 'Failed to disband group',
  addTeamMemberSuccessText: 'Member added successfully',
  addTeamMemberVerifyText: 'Waiting for verification',
  addTeamMemberFailedText: 'Failed to add member',
  addTeamMemberConfirmText: 'Please select the members to add',
  removeTeamMemberText: 'Remove member',
  removeTeamMemberConfirmText: 'Are you sure you want to remove this member?',
  removeTeamMemberSuccessText: 'Member removed successfully',
  removeTeamMemberFailedText: 'Failed to remove member',
  teamTitleConfirmText: 'Group name cannot be empty',
  teamAvatarConfirmText: 'Group avatar cannot be empty',
  teamIdText: 'Group ID',
  discussionIdText: 'Discussion Group ID',
  teamSignText: 'Group introduction',
  teamTitlePlaceholder: 'Please enter the group name',
  teamSignPlaceholder: 'Please enter content',
  teamOwnerText: 'Group owner',
  teamManagerText: 'Group manager',
  teamManagerEditText: 'Manage members',
  teamManagerEmptyText: 'No group managers yet',
  teamOwnerAndManagerText: 'Group owner and managers',
  updateTeamManagerSuccessText: 'Group manager updated successfully',
  updateTeamManagerFailText: 'Failed to update group manager',
  userNotInTeam: 'Member is no longer in the group',
  teamMemberNotExist: 'This group chat does not exist',
  teamManagerLimitText: 'Who can edit description?',
  teamJoinModeText: 'Team join mode',
  teamAgreeModeText: 'Team agree mode',
  teamAgreeModeExplainText: 'Enabled invitations require invitee acceptance.',
  teamInviteModeText: 'Who can add new members?',
  teamAtModeText: 'Who can @ all members?',
  teamTopModeText: 'Who can pin messages?',
  teamMemberText: 'Group members',
  discussionMemberText: 'Discussion group members',
  teamInfoText: 'Group information',
  discussionText: 'Discussion group information',
  teamPowerText: 'Group management',
  dismissTeamText: 'Disband group',
  transferOwnerText: 'Transfer group',
  newGroupOwnerText: 'Become the new group owner',
  beAddTeamManagersText: 'Appointed as manager',
  beRemoveTeamManagersText: 'Removed from manager',
  transferTeamFailedText: 'Failed to transfer group ownership',
  transferToText: 'Transfer to',
  transferTeamSuccessText: 'Group ownership transferred successfully',
  transferOwnerConfirmText: 'Are you sure you want to transfer group ownership',
  dismissTeamConfirmText: 'Are you sure you want to disband this group',
  leaveTeamTitle: 'Leave group',
  leaveDiscussionTitle: 'Exit discussion group',
  leaveTeamConfirmText: 'Leave group or not?',
  leaveDiscussionConfirmText: 'Exit discussion group or not?',
  personUnit: 'person',
  leaveTeamButtonText: 'Delete and leave',
  leaveDiscussionButtonText: 'Exit discussion group',
  sendMsgFailedText: 'Message sending failed',
  getHistoryMsgFailedText: 'Failed to get history messages',
  sendBlackFailedText: 'You have been blacklisted by the other party',
  sendNotFriendFailedText: 'Not friends currently',
  recallMessageText: 'Recalled a message',
  recallReplyMessageText: 'This message has been recalled or deleted',
  tipAIMessageText: 'Format not supported',
  tipAIFailedMessageText: 'Request to large language model failed',
  memberNotExistsText: 'User does not exist',
  aiAntiSpamText: 'AI request hit anti-spam',
  aiFunctionDisabled: 'AI message function not enabled',
  aiMemberBanned: 'User is banned',
  aiMemberChatBanned: 'User is muted',
  aiFriendNotExists: 'Friend does not exist',
  aiMessageHitAntiSpam: 'Message hit anti-spam',
  notAnAi: 'Not an AI account',
  aiTeamMemberNotExists: 'Group member does not exist',
  aiNormalTeamChatBanned: 'Normal group members are muted',
  aiTeamChatBanned: 'Group member is muted',
  aiBlockFailedText: 'Blocking AI accounts is not allowed',
  aiRateLimit: 'Rate limit exceeded',
  aiParameterError: 'Parameter error',
  teamDoNotDisturbText: 'Group Do Not Disturb',
  discussionDoNotDisturbText: 'Discussion group Do Not Disturb',

  reeditText: 'Edit again',
  addChatMemberText: 'Add chat member',
  chatHistoryText: 'Chat history',
  noMoreText: 'No more messages',
  noMoreCollectionText: 'Reached the bottom~',
  receiveText: 'You have received a new message',
  strangerNotiText:
    'This person is not your friend, please protect your privacy and safety.',
  nickInTeamText: 'My nickname in the group',
  editNickInTeamText: 'Edit my nickname in the group',
  updateMyMemberNickSuccess: 'Successfully updated my group nickname',
  updateMyMemberNickFailed: 'Failed to update my group nickname',
  updateBitConfigMaskSuccess:
    'Successfully updated group message Do Not Disturb',
  updateBitConfigMaskFailed: 'Failed to update group message Do Not Disturb',
  imgText: 'Image',
  videoText: 'Video',
  onlineText: '(Online)',
  offlineText: '(Offline)',
  pinAIText: 'PIN to top',
  aiSearchText: 'AI word search',
  aiSearchingText: 'AI searching...',
  aiProxyFailedText: 'Model request exception',
  aiSearchInputPlaceholder: 'Enter more information',
  aiTranslateText: 'AI processing',
  aiTranslatingText: 'AI processing...',
  aiTranslatedText: 'Using',
  aiTranslatePlaceholder: 'Translate to...',
  aiTranslateEmptyText: 'Please enter the content to translate',
  aiSendingText: 'Large model request in response',
  searchTipText: 'Press Enter to search',
  aiErrorText: 'The server is busy. Please try again later.',
  aiStopFailedText: 'Stop failed',
  regenAIMsgFailedText: 'Regeneration failed',
  aiStreamCancelText: 'Request cancelled',

  // emoji 不能随便填，要用固定 key
  Laugh: '[Laugh]',
  Happy: '[Happy]',
  Sexy: '[Sexy]',
  Cool: '[Cool]',
  Mischievous: '[Mischievous]',
  Kiss: '[Kiss]',
  Spit: '[Spit]',
  Squint: '[Squint]',
  Cute: '[Cute]',
  Grimace: '[Grimace]',
  Snicker: '[Snicker]',
  Joy: '[Joy]',
  Ecstasy: '[Ecstasy]',
  Surprise: '[Surprise]',
  Tears: '[Tears]',
  Sweat: '[Sweat]',
  Angle: '[Angle]',
  Funny: '[Funny]',
  Awkward: '[Awkward]',
  Thrill: '[Thrill]',
  Cry: '[Cry]',
  Fretting: '[Fretting]',
  Terrorist: '[Terrorist]',
  Halo: '[Halo]',
  Shame: '[Shame]',
  Sleep: '[Sleep]',
  Sleeping: '[Sleeping]',
  Tired: '[Tired]',
  Mask: '[Mask]',
  AllRight: '[All right]',
  Despise: '[Despise]',
  Uncomfortable: '[Uncomfortable]',
  huff: '[Huff]',
  Disdain: '[Disdain]',
  ill: '[ill]',
  Mad: '[Mad]',
  Ghost: '[Ghost]',
  Angry: '[Angry]',
  Unhappy: '[Unhappy]',
  Frown: '[Frown]',
  Broken: '[Broken]',
  Beckoning: '[Beckoning]',
  Ok: '[Ok]',
  Low: '[Low]',
  Nice: '[Nice]',
  Applause: '[Applause]',
  GoodJob: '[Good job]',
  Hit: '[Hit]',
  Please: '[Please]',
  Bye: '[Bye]',
  First: '[First]',
  Fist: '[Fist]',
  GiveMeFive: '[Give me five]',
  Knife: '[Knife]',
  Hi: '[Hi]',
  No: '[No]',
  Hold: '[Hold]',
  Think: '[Think]',
  Pig: '[Pig]',
  NoListen: '[No listen]',
  NoLook: '[No look]',
  NoWords: '[No words]',
  Monkey: '[Monkey]',
  Bomb: '[Bomb]',
  Cloud: '[Cloud]',
  Rocket: '[Rocket]',
  Ambulance: '[Ambulance]',
  Poop: '[Poop]',
  session: 'session',
  addressText: 'contacts',
  sdkVersionSelectionText: 'SDK version',
  p2pMsgVisibleModeText: 'Read receipts for private messages',
  teamMsgVisibleModeText: 'Read receipts for group messages',
  addFriendMode: 'Verification for friend requests',
  logoutText: 'Sign out',
  yesText: 'Enable',
  noText: 'Disable',
  needVerifyText: 'Required',
  notNeedVerifyText: 'Not required',
  settingText: 'setting',
  logoutConfirmText: 'Are you sure you log out?',
  voiceCallText: 'Voice Call',
  vedioCallText: 'Vedio Call',
  oppositeSide: 'The opposite side',
  networkDisconnectText:
    'The network connection has been disconnected. Please check your network settings and try to reconnect.',
  callFailed: 'call failed',
  inCallText: 'Already in a call, please try again after ending the call',
  passFriendAskText: "I have approved your request, let's start chatting now~",
  needMentionText: 'Whether or not an @ message is needed',
  teamManagerEnableText: 'Whether or not team manager is needed',
  collectionText: 'collection',
  zhText: '中文',
  enText: 'English',
  securityTipText:
    'Only for testing the Netease IM , please do not believe in money transfer, lottery winning and so on. Do not easily call strangers.',
  enableV2CloudConversationText: 'Whether or not to enable cloud conversation',
  aiStreamText: 'AI Stream',
  teamJoinModeFreeText: 'Free join, no verification required',
  teamJoinModeNeedVerifyText:
    'Need to apply, join after the group owner or manager approves',
  needBeInvitedText: 'Need to be invited by the invitee',
  notNeedBeInvitedText: 'No need to be invited by the invitee',
}

const emojiLocaleConfig = {}

export default LocaleConfig
